// Common NotFound.

import React from 'react';
import { useState, useEffect } from 'react';
//import Config from '../lib/Config'; //'../../lib/Config';
import '../assets/style/fonts.css'; //'../../assets/style/fonts.css';
//import Util from '../lib/Util'; //from '../../lib/Util';
import MainHeader from './MainHeader';
import MainFooter from './MainFooter';
import WarningIcon from '@mui/icons-material/Warning';


export default () => {

    //const [lang, setLang] = useState(Config.SERVICE_DEFAULT_LANGUAGE);
    //const navigate = useNavigate();

    useEffect(() => {
      //  setLang(Util.get_url_lang());
    }, []);



    return (
        <div style={{ width: '100%', height: '98vh', fontFamily: 'Roboto', fontSize: '13px', padding:'0x' }}>
            <table className={"base_table"} cellspacing={'0px'} cellpadding={'0px'}>
                <tr>
                    <td style={{height:'48px'}}>
                        <MainHeader />
                    </td>
                </tr>
                <tr>
                    <td style={{textAlign:'center',verticalAlign:'center'}}>

                    <WarningIcon style={{color:'#555555',fontSize:'130px',margin:'0px auto'}} />
                    <div style={{height:'80px',fontSize:'18px',color:'#222222'}}>PAGE NOT FOUND</div>
                    <div style={{height:'180px',fontSize:'18px',color:'#222222'}}>&nbsp;&nbsp;</div>

                    </td>
                </tr>
                <tr>
                    <td style={{height:'200px',textAlign:'center'}}>
                    <MainFooter />
                    </td>
                </tr>
            </table>

        </div>

    );

}